import {ADD_SKILL_OPTION, ADD_SKILL_OPTION_SUCCESS, ADD_SKILL_OPTION_FAILED} from "../actions/addSkillOption";
import {errorMessageFromPayload} from "../utils/errors";
import {SYNC_RESET_DEVICE_SUCCESS} from "../actions/sync";

const defaultState = {
  adding: false,
  error: '',
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case ADD_SKILL_OPTION: {
      return {
        ...state,
        adding: true,
        error: '',
      };
    }
    case ADD_SKILL_OPTION_SUCCESS: {
      return {
        ...state,
        adding: false,
      };
    }
    case ADD_SKILL_OPTION_FAILED: {
      return {
        ...state,
        adding: false,
        error: errorMessageFromPayload(action.payload),
      };
    }
    case SYNC_RESET_DEVICE_SUCCESS: {
      return defaultState;
    }
    default:
      return state;
  }
}
